import { memo } from 'react';

import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { SkillPillFragment } from '@/modules/events/graphql/fragments/generated/SkillPill';

export interface SkillPillProps {
  className?: string;
  skill: SkillPillFragment;
}

function SkillPill(props: SkillPillProps) {
  const { className, skill } = props;

  return (
    <Stack
      alignItems="center"
      className={cn('h-32 rounded-full border border-border px-12', className)}>
      <Typography color="text-text-primary" variant="body-short-02">
        {skill.name}
      </Typography>
    </Stack>
  );
}

export default memo(SkillPill);
